export class ClipboardService{
    public static copyToClipboard(text: string): boolean {
        const previouslyFocused = document.activeElement as HTMLElement | null;
        let input = document.createElement('textarea');
        input.style.position = 'fixed';
        input.style.top = '-5px';
        input.style.border = 'none';
        input.style.outline = 'none';
        input.style.boxShadow = 'none';
        input.style.background = 'transparent';
        input.value = text;
        document.body.appendChild(input);
        input.focus();
        input.select();
        try {
            return document.execCommand('copy');
        } finally {
            document.body.removeChild(input);
            previouslyFocused?.focus();
        }
    }
}